import { getRumShim as u } from "./datadog.helper.js";
var p = 50, f = "dd:rum-ready", r = [], h = !1, m = (e, t) => {
  try {
    e(t);
  } catch {
  }
}, n = () => {
  const e = u();
  if (!e) return;
  const t = [], a = [];
  r.forEach((i) => (i.supports(e) ? t : a).push(i)), r.length = 0, r.push(...a), t.forEach((i) => m(i.call, e));
}, v = () => {
  h || (h = !0, window.addEventListener(f, n), window.addEventListener("load", n));
}, d = (e, t) => {
  n();
  const a = u();
  if (t(a)) {
    m(e, a);
    return;
  }
  r.length >= 50 && r.shift(), r.push({
    call: e,
    supports: t
  }), v();
}, l = (e) => typeof e?.setViewName == "function", s = null, o = (e) => {
  s && e.setViewName?.(s);
}, w = () => r.some((e) => e.call === o), N = (e) => {
  if (!e) return;
  s = e;
  const t = u();
  if (l(t)) {
    t?.setViewName?.(e);
    return;
  }
  w() || d(o, l);
}, V = () => {
  r.length = 0, s = null;
};
export {
  p as MAX_PENDING,
  f as RUM_READY_EVENT,
  V as resetPendingRumCalls,
  N as setRumViewName,
  d as withRumShim
};

//# sourceMappingURL=rum.helper.js.map